export default function StorySection({ copy }) {
  return (
    <section id="story" className="story section-shell">
      <div className="section-intro">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h2>{copy.title}</h2>
      </div>
      <div className="story-copy">
        <p>{copy.copy}</p>
        <span className="handwritten">{copy.details}</span>
      </div>
    </section>
  );
}